import preval from 'preval.macro';

// Name of the redux form main form
const formName = 'application';
const cancelFormName = 'cancelApplication';
const samplePolicyFormName = 'samplePolicy';

const saveQuoteFormName = 'saveQuote';

// The time this app was built. Can be used for cache-busting for example.
const buildTime = preval`module.exports = Date.now()`;

// The ONEBEACON API URL formatted to match the local address when in dev
// used to avoid issues accessing hosts from the network
// e.g. if localhost, but testing from a phone using local IP such as 192.168.1.1, assume the API is also the same IP
const regex = /(localhost|127.0.0.1)/;
const url = new URL(process.env.REACT_APP_ONEBEACON_API_LOCATION);
if (regex.test(url.hostname)) {
  url.hostname = window.location.hostname;
}
const apiUrl = url.href;

// Query params code
const SOURCE_CODE_PARAM = 's';
const VENUE_CODE_PARAM = 'v';
const FACILITY_CODE_PARAM = 'f';

// Thank you page download timeout
const DOCUMENT_DOWNLOAD_WINDOW = 7200; // seconds, or 2 hours

// Vendor references
const PERFORMER = 'Performer';
const FOOD_VENDOR = 'Food Vendor';
const GOODS_VENDOR = 'Goods Vendor';
const EXHIBITOR = 'Exhibitor';

const US_TERRITORIES = ['PR', 'VI'];

const PERMISSION_MANAGE_SETTINGS = 'Manage Settings';

export {
  formName,
  cancelFormName,
  samplePolicyFormName,
  saveQuoteFormName,
  buildTime,
  apiUrl,
  SOURCE_CODE_PARAM,
  VENUE_CODE_PARAM,
  FACILITY_CODE_PARAM,
  DOCUMENT_DOWNLOAD_WINDOW,
  PERFORMER,
  FOOD_VENDOR,
  GOODS_VENDOR,
  EXHIBITOR,
  US_TERRITORIES,
  PERMISSION_MANAGE_SETTINGS,
};
